"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _parsers = require("./parsers");

function objToString(styleObj) {
  var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _parsers.camelToKebab;

  if (!styleObj || _typeof(styleObj) !== 'object' || Array.isArray(styleObj)) {
    throw new TypeError("expected an argument of type object, but got ".concat(_typeof(styleObj)));
  }

  var lines = Object.keys(styleObj).map(function (property) {
    return "".concat(parser(property), ": ").concat(styleObj[property], ";");
  });
  return lines.join('\n');
}

var _default = objToString;
exports["default"] = _default;